import React from "react";
import SectionPage from "@/components/SectionPage";

export default function Philosophy() {
  return <SectionPage sectionKey="philosophy" />;
}
